import React from 'react';
import PropTypes from 'prop-types';
import InfoModal from '../../components/searchBox/infoModal/InfoModal';
import I18n from 'i18n-react';
import { Button } from 'react-bootstrap';
import { Redirect } from 'react-router-dom';
import Login from '../login/Login';
import LoginCallcenter from '../loginCallcenter/LoginCallcenter';
import LoginCookie from '../loginCookie/LoginCookie';
import PointsBalance from '../pointsBalance/PointsBalance';
import * as LoginCallcenterUC from '../../usecases/loginCallcenter/LoginCallcenterUC';
import TrackME from '../modules/trackMe';
import { isFromCallcenter } from '../../services/queryService/QueryService';
import Moment from 'moment';
import './LoginContainer.css';
import Identity from '../modules/identity';
import LocalStorage from '../../const/LocalStorage';

const POST_LOGIN_V1 = '/platform-session/api/v1/login/';
const POST_CUSTOMER_V1 = '/platform-session/api/v1/customer';

const propTypes = {
  quotationJourney: PropTypes.object.isRequired,
  flightsFilter: PropTypes.object.isRequired,
  analyticsDataSelect: PropTypes.object.isRequired,
  callbackAlterSearch: PropTypes.func,
  location: PropTypes.object,
  isCallcenterEnabled: PropTypes.bool
};

const defaultProps = {
  location: {
    search: null
  }
};

class LoginContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      openModal: false,
      messageInfo: null,
      isRedirect: false,
      pathname: '/',
      isLoginInCookie: false,
      showLoginLoading: false,
      showLoginCallcenterLoading: false,
      termIsChecked: false,
      pointsBalance: {
        display: false,
        name: '',
        totalPoints: 0,
        differenceTotalPoints: 0,
        callbackAlterSearch: this.props.callbackAlterSearch
      },
      isCallcenterEnabled: this.props.isCallcenterEnabled
    };

    this.showModal = this.showModal.bind(this);
    this.login = this.login.bind(this);
    this.loginCallcenter = this.loginCallcenter.bind(this);
  }

  componentDidMount() {
    if (this.callCenterMode()) {
      if (localStorage.getItem(LocalStorage.CUSTOMER_DATA_CALLCENTER)){
        this.setState({
          isLoginInCookie: true
        });
      }
    }
  }

  callCenterMode() {
    return this.state.isCallcenterEnabled && isFromCallcenter();
  }

  getLoginCookie = user => {
    if (user) {
      this.setState({
        isLoginInCookie: true
      });
      this.getPointsBalance(user.firstName, user.pointsBalance);
    }
  };

  redirect = () => {
    this.setState({
      isRedirect: true,
      pathname: '/passengers'
    });
  };

  featureIdentity(sessionId, domain) {
    Identity.capturar(sessionId, domain);
  }

  login(loginValue, password) {
    let body = {
      customerLogin: {
        login: loginValue,
        password: password
      }
    };

    let data, message, statuscode;
    this.setState({
      showLoginLoading: true
    });

    return fetch(POST_LOGIN_V1, {
      method: 'POST',
      body: JSON.stringify(body),
      headers: new Headers({
        'Content-Type': 'application/json'
      }),
      credentials: 'same-origin'
    })
      .then(res => {
        if (res.ok) {
          return res.json();
        } else if (res.status === 422) {
          message = this.getInvalidLoginMessage();
          throw res.json();
        } else if (res.status === 401) {
          statuscode = 401;
          throw res.json();
        } else {
          throw res.json();
        }
      })
      .then(body => {
        data = body;
        return fetch(POST_CUSTOMER_V1, {
          method: 'GET',
          headers: new Headers({
            'Content-Type': 'application/json',
            username: data.username
          }),
          credentials: 'same-origin'
        });
      })
      .then(res => {
        if (res.ok) {
          return res.json();
        } else {
          throw res.json();
        }
      })
      .then(body => {
        data = { ...data, ...body };
        this.setState({
          data: data,
          isLoginInCookie: true,
          showLoginLoading: false
        });
        TrackME.run(loginValue, 'LOGIN');
        this.featureIdentity(loginValue, 'LOGIN');
        let validateBalance = this.getPointsBalance(data.firstName, data.pointsBalance);
        if (validateBalance) {
          this.redirect();
        }
      })
      .catch(promise => {
        this.setState({
          isLoginInCookie: false,
          showLoginLoading: false
        });
        let description = '';
        let reason = '';
        let telLabel = I18n.translate('components.login.tudoAzulTel');
        let emailLabel = I18n.translate('components.login.tudoAzulEmail');
        let tel = <a href={`tel:${telLabel}`}> {telLabel} </a>;
        let email = <a href={`mailto:${emailLabel}`}> {emailLabel} </a>;
        promise
          .then(value => {
            message = value.message;
            description = value.description;
            reason = value.reason;
            const errorCode = value.code;

            if (statuscode === 401) {
              message = this.getInvalidLogin_401_Message();
              this.showModal(message);
            } else if (errorCode === "590"){
              this.showModal(this.getMessageCustomerFieldsNull(message));            
            } else if (errorCode === '516') {
              this.showModal(this.getInvalidLogin_500_Message(message));
            } else if (message != null && description != null && reason != null) {
              let text = (
                <div>
                  <p>{I18n.translate('home.msg.error')}</p>
                  <br />
                  <p>Mensagem: </p>
                  <p>{I18n.translate(message, { tel: tel, email: email })}</p>
                  <br />
                  <p>Descrição: </p>
                  <p>{description}</p>
                  <br />
                  <p>Razão: </p>
                  <p>{reason}</p>
                </div>
              );
              this.showModal(text);
            } else if (message != null && description != null) {
              let text = (
                <div>
                  <p>{I18n.translate('home.msg.error')}</p>
                  <br />
                  <p>Mensagem:</p>
                  <p>{I18n.translate(message, { tel: tel, email: email })}</p>
                  <br />
                  <p>Descrição: </p>
                  <p>{description}</p>
                </div>
              );
              this.showModal(text);
            } else if (message) {
              let text = (
                <div>
                  <p>{I18n.translate('home.msg.error')}</p>
                  <br />
                  <p>Mensagem: </p>
                  <p>{I18n.translate(message, { tel: tel, email: email })}</p>
                </div>
              );
              this.showModal(text);
            } else if (description) {
              let text = (
                <div>
                  <p>{I18n.translate('home.msg.error')}</p>
                  <br />
                  <p>Descrição: </p>
                  <p>{description}</p>
                </div>
              );
              this.showModal(text);
            } else if (reason) {
              let text = (
                <div>
                  <p>{I18n.translate('home.msg.error')}</p>
                  <br />
                  <p>Razão: </p>
                  <p>{reason}</p>
                </div>
              );
              this.showModal(text);
            } else {
              this.showModal(I18n.translate('home.msg.error'));
            }
          })
          .catch(() => {
            if (message) {
              this.showModal(message);
            } else {
              this.showModal(I18n.translate('home.msg.error'));
            }
          });
      });
  }

  loginCallcenter(username) {
    let data, message;
    this.setState({
      showLoginCallcenterLoading: true
    });
    LoginCallcenterUC.execute(username)
      .then(body => {
        data = {
          ...body.data,
          username: body.data.login,
          pointsBalance: '' + body.data.totalPointBalance
        };

        this.setState({
          isLoginInCookie: true,
          data: data,
          showLoginCallcenterLoading: false
        });

        localStorage.setItem(LocalStorage.CUSTOMER_DATA_CALLCENTER, JSON.stringify({...data, expirationCustomer : this.expirationCustomerCallcenter()}));

        let validateBalance = this.getPointsBalance(data.firstName, data.pointsBalance);

        if (validateBalance) {
          this.redirect();
        }
      })
      .catch(error => {
        this.setState({
          isLoginInCookie: false,
          showLoginCallcenterLoading: false
        });
        if (error.response && error.response.status === 401) {
          message = this.getInvalidLogin_401_Message();
          this.showModal(message);
        } else {          
          const errorMessage = (error.response && error.response.data);
          if(errorMessage && errorMessage.code === "590")
           this.showModal(this.getMessageCustomerFieldsNull(errorMessage.message))
          else
           this.showModal(I18n.translate('home.msg.error'));
        }
      });
  }

  getPointsBalance(nameData, pointsBalanceData) {
    let totalAdult, totalChildren, totalInfant, total;

    totalAdult =
      this.props.quotationJourney.departureFlight.value +
      (this.props.quotationJourney.returnFlight
        ? this.props.quotationJourney.returnFlight.value
        : 0);
    totalAdult = totalAdult * this.props.quotationJourney.passengers.adultNumber;

    if (this.props.quotationJourney.departureFlight.childValue) {
      totalChildren =
        this.props.quotationJourney.departureFlight.childValue +
        (this.props.quotationJourney.returnFlight
          ? this.props.quotationJourney.returnFlight.childValue
          : 0);
      totalChildren = totalChildren * this.props.quotationJourney.passengers.childNumber;
    }

    if (this.props.quotationJourney.departureFlight.infantValue) {
      totalInfant =
        this.props.quotationJourney.departureFlight.infantValue +
        (this.props.quotationJourney.returnFlight
          ? this.props.quotationJourney.returnFlight.infantValue
          : 0);
      totalInfant = totalInfant * this.props.quotationJourney.passengers.infantNumber;
    }
    total = totalAdult + (totalChildren ? totalChildren : 0) + (totalInfant ? totalInfant : 0);

    if (pointsBalanceData - total < 0) {
      this.setState({
        pointsBalance: {
          display: true,
          name: nameData,
          totalPoints: pointsBalanceData,
          differenceTotalPoints: total - pointsBalanceData,
          callbackAlterSearch: this.props.callbackAlterSearch
        }
      });
      return false;
    }
    return true;
  }

  getInvalidLoginMessage() {
    let telLabel = I18n.translate('components.login.tudoAzulTel');
    let emailLabel = I18n.translate('components.login.tudoAzulEmail');
    let tel = <a href={`tel:${telLabel}`}> {telLabel} </a>;
    let email = <a href={`mailto:${emailLabel}`}> {emailLabel} </a>;

    return I18n.translate('components.login.invalidLoginErrorMessage', { tel: tel, email: email });
  }

  getInvalidLogin_401_Message() {
    return I18n.translate('components.login.invalidLoginError401Message');
  }

  getInvalidLogin_500_Message() {
    return I18n.translate('components.login.invalidLogin');
  }

  getMessageCustomerFieldsNull(message) {
    const telCapital = I18n.translate('components.loginCallcenter.tudoAzulTel');
    const telGeral = I18n.translate('components.loginCallcenter.tudoAzulTelGlobal');
    return (
      <div>
        <p>{I18n.translate(message+'.title')}</p>             
        <p>{I18n.translate(message+'.description',{telCapital:telCapital,telGeral:telGeral})}</p>        
      </div>
    );
  }

  showModal(message) {
    this.setState({
      openModal: true,
      messageInfo: message
    });
  }

  closeModal() {
    this.setState({
      openModal: false,
      messageInfo: null
    });
  }

  expirationCustomerCallcenter() {
    return Moment()
      .add(global.env.CALLCENTER_COOKIE_LOGIN_EXPIRATION || 30, 'minutes')
      .toDate()
      .toISOString();
  }

  renderPointsBalance() {
    if (this.state.isLoginInCookie && this.state.pointsBalance.display) {
      return (
        <PointsBalance
          name={this.state.pointsBalance.name}
          totalPoints={parseInt(this.state.pointsBalance.totalPoints, 10)}
          differenceTotalPoints={this.state.pointsBalance.differenceTotalPoints}
          callbackAlterSearch={this.props.callbackAlterSearch}
          ref={c => {
            this.pointsBalance = c;
          }}
        />
      );
    }
  }

  renderButtonProceedToPassengers() {
    if (this.state.isLoginInCookie && !this.state.pointsBalance.display) {
      if (!this.props.termIsChecked && this.props.checkboxBorderName != 'invalidField') {
        this.props.setCheckboxBorderNameCallback('invalidField');
      }
      return (
        <Button
          id="btnProceedToPassengers"
          className="button-finalize"
          onClick={this.redirect}
          disabled={!this.props.termIsChecked}>
          {I18n.translate('flight.btn.proceedToPassengers')}
        </Button>
      );
    }
  }

  renderLogin() {
    if (
      !this.state.isLoginInCookie &&
      !this.state.pointsBalance.display &&
      !this.callCenterMode()
    ) {
      let loginContainerClasses =
        'LoginContainer__loginWithLoader LoginContainer__' +
        (this.state.showLoginLoading ? 'showLoader' : 'hiddenLoader');
      return (
        <div className="LoginContainer__loaderWrapper">
          <Login
            id="login"
            changeValue={this.login}
            showLoginLoading={this.state.showLoginLoading}
            termIsChecked={this.props.termIsChecked}
            setCheckboxBorderNameCallback={this.props.setCheckboxBorderNameCallback}
          />
          <div className={loginContainerClasses}>
            <div className="LoginContainer__loginWithLoader__mask" />
            <div className="LoginContainer__loginWithLoader__spinner">
              <i className="icon-spinner" />
            </div>
          </div>
        </div>
      );
    }
  }

  renderLoginCallcenter() {
    if (!this.state.isLoginInCookie && !this.state.pointsBalance.display && this.callCenterMode()) {
      let loginCallcenterContainerClasses =
        'LoginContainer__loginWithLoader LoginContainer__' +
        (this.state.showLoginCallcenterLoading ? 'showLoader' : 'hiddenLoader');
      return (
        <div className="LoginContainer__loaderWrapper">
          <LoginCallcenter
            id="loginCallcenter"
            changeValue={this.loginCallcenter}
            showLoginCallcenterLoading={this.state.showLoginCallcenterLoading}
            termIsChecked={this.props.termIsChecked}
            setCheckboxBorderNameCallback={this.props.setCheckboxBorderNameCallback}
          />
          <div className={loginCallcenterContainerClasses}>
            <div className="LoginContainer__loginWithLoader__mask" />
            <div className="LoginContainer__loginWithLoader__spinner">
              <i className="icon-spinner" />
            </div>
          </div>
        </div>
      );
    }
  }

  renderLoginCookie() {
    if (!this.callCenterMode()) {
      return (
        <LoginCookie
            callbackCookie={this.getLoginCookie}
            data={this.state.data}
            callcenterMode={this.callCenterMode()}
          />
      );
    }
  }

  render() {
    return (
      <div id="login">
        {(() => {
          if (this.state.isRedirect) {
            return (
              <Redirect
                push
                to={{
                  pathname: this.state.pathname,
                  state: {
                    quotationJourney: this.props.quotationJourney,
                    flightsFilter: this.props.flightsFilter,
                    analyticsDataSelect: this.props.analyticsDataSelect,
                    isCallcenterEnabled: this.state.isCallcenterEnabled
                  },
                  search: this.props.location.search
                }}
              />
            );
          } else {
            return (
              <div>
                {this.renderPointsBalance()}
                {this.renderButtonProceedToPassengers()}
                {this.renderLogin()}
                {this.renderLoginCallcenter()}
                <InfoModal
                  id="modalLoginInfo"
                  message={this.state.messageInfo}
                  showModal={this.state.openModal}
                  close={() => this.closeModal()}
                  ref={c => {
                    this.modalLoginInfo = c;
                  }}
                />
                {this.renderLoginCookie()}                
              </div>
            );
          }
        })()}
      </div>
    );
  }
}

LoginContainer.propTypes = propTypes;
LoginContainer.defaultProps = defaultProps;

export default LoginContainer;



// WEBPACK FOOTER //
// ./src/components/loginContainer/LoginContainer.jsx